import React, { useState, useEffect } from 'react';
import './ClubPromotion2.css';
import { AnimatedSection } from '../../AnimatedSection';

const ClubPromotion2 = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [IsDirection, setIsDirection] = useState(false);

  const images = [
    { src: "/home_data/section8/1.png", height: '100px', alt: "Image 1" },
    { src: "/home_data/section8/2.png", height: '100px', alt: "Image 2" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      // Change direction first
      setIsDirection(prevDirection => !prevDirection);

      // Start slide animation
      setIsAnimating(true);

      // After slide animation completes, change image and reset animation
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
        setIsAnimating(false); // Reset animation state
      }, 1500); // Animation duration (matching CSS transition)

    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="club-promotion-2 section">
      <div className="container-background">
        <div className="club-content">
          <div className="club-image">
            <div style={{ width: '100vw' }}>
              <div className="slider-wrapper">
                <div className={`slider-image-container ${isAnimating ? (IsDirection ? 'slide-left' : 'slide-right') : 'center'}`}>
                  <img
                    src={images[currentImageIndex].src}
                    style={{
                      width: images[currentImageIndex].width,
                      height: images[currentImageIndex].height
                    }}
                    alt={images[currentImageIndex].alt}
                    className="slider-image"
                  />
                </div>

                <AnimatedSection>
                  <div className="club-text">
                    <span>OFFICIAL PARTNER</span>
                    <h1 className="club-text-title">NY RANGERS</h1>
                  </div>
                </AnimatedSection>


              </div>

            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default ClubPromotion2;